module.exports = __webpack_public_path__ + "static/img/004.b9885c65.png";